import En from './en'
import Fr from './fr'
export default {
  en: En,
  fr: Fr
}



// WEBPACK FOOTER //
// ./src/lang/index.js